<template>
  <div>
    <!-- <v-overlay v-if="loading"> -->

    <v-overlay v-if="errorDialog == true">
      <v-card>
        <v-alert
          style="border-radius: 12px"
          color="#DB4437"
          dismissible
          :value="true"
          prominent
          icon="fas fa-exclamation-triangle"
          ><p>
            {{ errorMessage }}
          </p></v-alert
        >
      </v-card>
    </v-overlay>

    <!-- </v-overlay> -->
    <v-card style="border-radius: 12px" v-if="errorDialog == false">
      <div class="grid">
        <Loader v-if="loading" />
      </div>

      <div class="grid mt-8" v-if="!loading">
        <v-row>
          <v-card class="mr-5" style="border-radius: 12px">
            <base-img
              :src="require('@/assets/logos/icon1.svg')"
              class="mx-auto pa-6"
              contain
              width="32"
            />
          </v-card>
          <v-img
            class="mt-5 mr-4"
            :style="
              $vuetify.breakpoint.xsOnly
                ? 'height: 10px; width: 10px;'
                : '' && $vuetify.breakpoint.smAndDown
                ? 'height: 30px; width: 30px;'
                : 'height: 30px; width: 30px;' && $vuetify.breakpoint.mdAndUp
                ? 'height: 18px; width: 18px;'
                : 'height: 12px; width: 12px;'
            "
            :src="
              require('@/assets/fontawesome/arrow-right-arrow-left-regular.svg')
            "
          />
          <v-card style="border-radius: 12px">
            <base-img
              :src="require('@/assets/logos/stitch-s.svg')"
              class="mx-auto pa-6"
              contain
              width="32"
            />
          </v-card>
        </v-row>
        <v-divider></v-divider>
        <v-card-title class="text-center mt-4">Verify with Stitch</v-card-title>

        <v-card-text class="text-body-2 text-center">
          For your own safety and the safety of fellow Strappers you are
          required to verify your profile before any bookings can be finalized.
        </v-card-text>

        <v-btn to="/stitch" target="_blank" class="text-app" small
          >Learn more about Stitch
          <v-icon small class="ml-1">mdi-open-in-new</v-icon></v-btn
        >

        <v-divider></v-divider>
        <v-card-text class="text-body-2 text-center">
          This allows you to access one click payments, payouts and seemless
          refunds.

          <br /><br />
          <v-divider></v-divider>

          <v-row class="grid">
            <link-pay-verify
              class="mt-7"
              @error="error"
              :booking="booking"
            ></link-pay-verify>
          </v-row>
        </v-card-text>

        <v-card-text>
          <p class="text-caption font-weight-bold text-left mt-n3">
            Linking your bank account will give us access to the following data
            which helps us prove that you are who you say you are:
          </p>
          <br />

          <p class="ml-3 text-caption">
            <v-row>
              <v-col cols="12" md="6"
                ><v-row>
                  <v-img
                    max-width="20px"
                    height="20px"
                    class="mr-3"
                    :src="
                      require('@/assets/fontawesome/shield-check-duotone.svg')
                    "
                  />
                  Full name</v-row
                ></v-col
              >
              <v-col cols="12" md="6"
                ><v-row>
                  <v-img
                    max-width="20px"
                    height="20px"
                    class="mr-3"
                    :src="
                      require('@/assets/fontawesome/shield-check-duotone.svg')
                    "
                  />
                  ID number</v-row
                ></v-col
              >
            </v-row>
          </p>
          <p class="ml-3 text-caption">
            <v-row>
              <v-col cols="12" md="6"
                ><v-row>
                  <v-img
                    max-width="20px"
                    height="20px"
                    class="mr-3"
                    :src="
                      require('@/assets/fontawesome/shield-check-duotone.svg')
                    "
                  />
                  Email address</v-row
                ></v-col
              >
              <v-col cols="12" md="6"
                ><v-row>
                  <v-img
                    max-width="20px"
                    height="20px"
                    class="mr-3"
                    :src="
                      require('@/assets/fontawesome/shield-check-duotone.svg')
                    "
                  />
                  Residential address</v-row
                ></v-col
              >
            </v-row>
          </p>
          <p class="ml-3 text-caption">
            <v-row>
              <v-col cols="12" md="12"
                ><v-row>
                  <v-img
                    max-width="20px"
                    height="20px"
                    class="mr-3"
                    :src="
                      require('@/assets/fontawesome/shield-check-duotone.svg')
                    "
                  />
                  Bank Account number
                </v-row></v-col
              >
            </v-row>
          </p>
          <br />
        </v-card-text>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'StrappStitchVerifyDialog',

  props: {
    booking: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    LinkPayVerify: () => import('@/components/LinkPayVerify.vue'),
    Loader: () => import('@/components/Loader.vue'),
  },

  computed: {
    loading() {
      return this.$store.getters.loading;
    },
  },

  data() {
    return {
      errormessage: '',
      errorDialog: false,
    };
  },

  mounted() {},

  methods: {
    error(error) {
      console.log('error', error);
      console.log(errorMessage);
      this.errorDialog = true;
      this.errorMessage = errorMessage;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
